import { instance } from "libs/api";

import { ApiRoutesWarehouses } from "../../constants";
import { CreateWarehouseBody, IWarehouse } from "../../warehouses.types";

export const requestCreateWarehouse = async (
  body: CreateWarehouseBody,
): Promise<IWarehouse> => {
  return await instance.post(ApiRoutesWarehouses.Warehouses, body);
};
